export default function maxmin({ number, max, min }) {
  return Math.min(Math.max(number, min), max);
}
